import React, { useState } from 'react';

const INITIAL_PROPS = [
  { id:1, name:'transferexpo_contact_type', label:'TransferExpo Contact Type', type:'Dropdown',     object:'Contact', group:'TransferExpo',  options:['Club','Scout','Agent','Player'], required:true,  system:true  },
  { id:2, name:'activation_status',         label:'Activation Status',          type:'Dropdown',     object:'Contact', group:'TransferExpo',  options:['Not Started','In Progress','Activated'], required:false, system:true  },
  { id:3, name:'affiliated_club',           label:'Affiliated Club',            type:'Single-line',  object:'Contact', group:'Scout',         options:[], required:false, system:true  },
  { id:4, name:'evaluation_tier',           label:'Evaluation Tier',            type:'Dropdown',     object:'Contact', group:'Scout',         options:['Standard','Premium'], required:false, system:true  },
  { id:5, name:'evaluations_count',         label:'Evaluations Count',          type:'Number',       object:'Contact', group:'Scout',         options:[], required:false, system:true  },
  { id:6, name:'membership_plan',           label:'Membership Plan',            type:'Dropdown',     object:'Contact', group:'Club',          options:['Basic','Pro','Enterprise'], required:false, system:true  },
  { id:7, name:'region',                    label:'Region',                     type:'Single-line',  object:'Contact', group:'Scout',         options:[], required:false, system:false },
  { id:8, name:'cert_level',               label:'Certification Level',         type:'Single-line',  object:'Contact', group:'Scout',         options:[], required:false, system:false },
];

const FIELD_TYPES = ['Single-line','Multi-line','Number','Dropdown','Checkbox','Date','Phone','Email'];
const OBJECTS     = ['Contact','Deal','Company'];
const GROUPS      = ['TransferExpo','Club','Scout','General','Billing'];

const typeBadge = t => {
  const colors = { 'Single-line':'#4fc3f7','Multi-line':'#4fc3f7','Number':'#f5a623','Dropdown':'#a78bfa','Checkbox':'#A7F432','Date':'#8a9a97','Phone':'#f5a623','Email':'#4fc3f7' };
  return <span style={{ padding:'3px 8px', borderRadius:99, fontSize:11, background:`${colors[t]||'#8a9a97'}22`, color:colors[t]||'#8a9a97' }}>{t}</span>;
};

export default function CustomProperties({ toast }) {
  const [props, setProps]       = useState(INITIAL_PROPS);
  const [filter, setFilter]     = useState('All');
  const [search, setSearch]     = useState('');
  const [creating, setCreating] = useState(false);
  const [newProp, setNewProp]   = useState({ name:'', label:'', type:'Single-line', object:'Contact', group:'General', options:[], required:false });
  const [optionInput, setOptionInput] = useState('');

  const filtered = props.filter(p=>{
    const matchFilter = filter==='All'||p.object===filter||p.group===filter;
    const matchSearch = !search||`${p.name} ${p.label}`.toLowerCase().includes(search.toLowerCase());
    return matchFilter && matchSearch;
  });

  const addProp = () => {
    if (!newProp.name||!newProp.label) { toast?.('Name and label are required','warning'); return; }
    const p = { id:Date.now(), ...newProp, system:false };
    setProps(prev=>[...prev,p]);
    setCreating(false);
    setNewProp({ name:'', label:'', type:'Single-line', object:'Contact', group:'General', options:[], required:false });
    toast?.('Property created');
  };

  const addOption = () => {
    if (!optionInput.trim()) return;
    setNewProp(p=>({...p, options:[...p.options, optionInput.trim()]}));
    setOptionInput('');
  };

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total properties</div><div className="stat-value">{props.length}</div><div className="stat-sub">All objects</div></div>
        <div className="stat-card"><div className="stat-label">Custom</div><div className="stat-value">{props.filter(p=>!p.system).length}</div><div className="stat-sub">User-created</div></div>
        <div className="stat-card"><div className="stat-label">System</div><div className="stat-value">{props.filter(p=>p.system).length}</div><div className="stat-sub">Built-in</div></div>
        <div className="stat-card"><div className="stat-label">Contact props</div><div className="stat-value">{props.filter(p=>p.object==='Contact').length}</div><div className="stat-sub">On contacts</div></div>
      </div>

      <div className="toolbar">
        <input className="search-input" placeholder="Search properties..." value={search} onChange={e=>setSearch(e.target.value)} />
        <button className="btn btn-primary" onClick={()=>setCreating(true)}>+ Create property</button>
      </div>

      <div className="filter-pills">
        {['All','Contact','Deal','TransferExpo','Scout','Club','General'].map(f=>(
          <button key={f} className={`pill ${filter===f?'active':''}`} onClick={()=>setFilter(f)}>{f}</button>
        ))}
      </div>

      {creating && (
        <div className="card" style={{ marginBottom:16 }}>
          <div className="card-header"><span className="card-title">Create property</span><button className="btn btn-ghost" style={{ fontSize:12 }} onClick={()=>setCreating(false)}>✕</button></div>
          <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:14 }}>
              <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Internal name *</label><input className="search-input" placeholder="e.g. scout_region" value={newProp.name} onChange={e=>setNewProp(p=>({...p,name:e.target.value.toLowerCase().replace(/\s/g,'_')}))} /></div>
              <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Display label *</label><input className="search-input" placeholder="e.g. Scout Region" value={newProp.label} onChange={e=>setNewProp(p=>({...p,label:e.target.value}))} /></div>
              <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Field type</label><select className="search-input" value={newProp.type} onChange={e=>setNewProp(p=>({...p,type:e.target.value}))}>{FIELD_TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
              <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Object</label><select className="search-input" value={newProp.object} onChange={e=>setNewProp(p=>({...p,object:e.target.value}))}>{OBJECTS.map(o=><option key={o}>{o}</option>)}</select></div>
              <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Group</label><select className="search-input" value={newProp.group} onChange={e=>setNewProp(p=>({...p,group:e.target.value}))}>{GROUPS.map(g=><option key={g}>{g}</option>)}</select></div>
              <div style={{ display:'flex', alignItems:'flex-end' }}><label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, color:'var(--text-muted)', paddingBottom:8 }}><input type="checkbox" checked={newProp.required} onChange={e=>setNewProp(p=>({...p,required:e.target.checked}))} />Required field</label></div>
            </div>
            {newProp.type === 'Dropdown' && (
              <div>
                <label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:6 }}>Dropdown options</label>
                <div style={{ display:'flex', gap:8, marginBottom:8 }}>
                  <input className="search-input" placeholder="Add option..." value={optionInput} onChange={e=>setOptionInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addOption()} style={{ flex:1 }} />
                  <button className="btn btn-ghost" onClick={addOption}>Add</button>
                </div>
                <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                  {newProp.options.map((o,i)=>(
                    <span key={i} style={{ padding:'4px 10px', background:'rgba(167,244,50,0.1)', borderRadius:99, fontSize:12, color:'var(--accent)', display:'flex', alignItems:'center', gap:6 }}>
                      {o}<button style={{ background:'none',border:'none',color:'var(--text-dim)',cursor:'pointer',fontSize:14,lineHeight:1,padding:0 }} onClick={()=>setNewProp(p=>({...p,options:p.options.filter((_,idx)=>idx!==i)}))}>×</button>
                    </span>
                  ))}
                </div>
              </div>
            )}
            <div style={{ display:'flex', gap:8 }}><button className="btn btn-primary" onClick={addProp}>Create property</button><button className="btn btn-ghost" onClick={()=>setCreating(false)}>Cancel</button></div>
          </div>
        </div>
      )}

      <div className="card" style={{ padding:0 }}>
        <div className="card-header" style={{ padding:'16px 20px', borderBottom:'1px solid var(--border)' }}>
          <span className="card-title">All properties</span>
          <span style={{ fontSize:12, color:'var(--text-dim)' }}>{filtered.length} properties</span>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Label</th><th>Internal name</th><th>Type</th><th>Object</th><th>Group</th><th>Required</th><th>System</th></tr></thead>
            <tbody>
              {filtered.map(p=>(
                <tr key={p.id}>
                  <td style={{ fontWeight:500 }}>{p.label}</td>
                  <td><code style={{ fontSize:11, color:'var(--accent)', background:'rgba(167,244,50,0.08)', padding:'2px 6px', borderRadius:4 }}>{p.name}</code></td>
                  <td>{typeBadge(p.type)}</td>
                  <td style={{ color:'var(--text-muted)', fontSize:12 }}>{p.object}</td>
                  <td style={{ color:'var(--text-muted)', fontSize:12 }}>{p.group}</td>
                  <td>{p.required?<span style={{ color:'#A7F432',fontSize:12 }}>Yes</span>:<span style={{ color:'var(--text-dim)',fontSize:12 }}>No</span>}</td>
                  <td>{p.system?<span className="badge badge-gray" style={{ fontSize:10 }}>System</span>:<span className="badge badge-green" style={{ fontSize:10 }}>Custom</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
